import React from "react";

const lbl = {
    display: "block",
    marginBottom: "0.3rem",
    fontSize: "0.78rem",
    fontWeight: 700,
    letterSpacing: "0.05em",
    textTransform: "uppercase",
    color: "#64748b",
};

const inputBase = {
    width: "100%",
    padding: "0.5rem 0.65rem",
    fontSize: "0.93rem",
    color: "#1e293b",
    background: "#f8fafc",
    border: "1px solid #e2e8f0",
    borderRadius: "8px",
    outline: "none",
    transition: "border-color 0.15s ease, box-shadow 0.15s ease",
};

const focusHandlers = {
    onFocus: (e) => {
        e.target.style.borderColor = "#2c7aa0";
        e.target.style.boxShadow = "0 0 0 3px rgba(44,122,160,0.12)";
        e.target.style.background = "#ffffff";
    },
    onBlur: (e) => {
        e.target.style.borderColor = "#e2e8f0";
        e.target.style.boxShadow = "none";
        e.target.style.background = "#f8fafc";
    },
};

const sectionHeader = {
    fontSize: "0.78rem",
    fontWeight: 700,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    color: "#64748b",
    margin: "1.5rem 0 0.75rem",
    paddingBottom: "0.4rem",
    borderBottom: "1px solid #f1f5f9",
};

const fieldWrap = { marginBottom: "1rem" };
const errMsg = { margin: "0.25rem 0 0", fontSize: "0.78rem", color: "#dc2626" };

const FormSaleWorkOrder = ({ newSale, setNewSale, validationErrors }) => {
    const handleUpdate = (field, value) => {
        if (field === "labourCost") {
            setNewSale((s) => ({ ...s, [field]: value }));
        } else {
            setNewSale((s) => ({ ...s, workOrder: { ...s.workOrder, [field]: value } }));
        }
    };

    const hasErr = validationErrors.includes("workOrder");

    return (
        <>
            <p style={sectionHeader}>Installation</p>

            <div
                style={{
                    display: "grid",
                    gridTemplateColumns:
                        newSale.workOrder.installationRequired === "Yes" ? "1fr 1fr" : "1fr",
                    gap: "1rem",
                    maxWidth: "28rem",
                }}
            >
                <div style={fieldWrap}>
                    <label style={{ ...lbl, color: hasErr ? "#dc2626" : "#64748b" }}>
                        Installation Required
                    </label>
                    <select
                        style={{ ...inputBase, borderColor: hasErr ? "#fca5a5" : "#e2e8f0" }}
                        name="installationRequired"
                        value={newSale.workOrder.installationRequired}
                        onChange={(e) => handleUpdate("installationRequired", e.target.value)}
                        {...focusHandlers}
                    >
                        <option value="">Select</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>
                    {hasErr && <p style={errMsg}>Required</p>}
                </div>

                {newSale.workOrder.installationRequired === "Yes" && (
                    <div style={fieldWrap}>
                        <label style={lbl}>Labour Cost</label>
                        <input
                            style={inputBase}
                            type="number"
                            name="labourCost"
                            value={newSale.labourCost}
                            onChange={(e) => handleUpdate("labourCost", e.target.value)}
                            {...focusHandlers}
                        />
                    </div>
                )}
            </div>
        </>
    );
};

export default FormSaleWorkOrder;
